<svg 
    [ngClass]="IconClass"
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    xmlns:xlink="http://www.w3.org/1999/xlink" 
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 14 14">
    <path d="M8 10.742v-1.484q0-0.109-0.074-0.184t-0.176-0.074h-1.5q-0.102 0-0.176 0.074t-0.074 0.184v1.484q0 0.109 0.074 0.184t0.176 0.074h1.5q0.102 0 0.176-0.074t0.074-0.184zM7.984 7.82l0.141-3.586q0-0.094-0.078-0.148-0.102-0.086-0.187-0.086h-1.719q-0.086 0-0.187 0.086-0.078 0.055-0.078 0.164l0.133 3.57q0 0.078 0.078 0.129t0.187 0.051h1.445q0.109 0 0.184-0.051t0.082-0.129zM7.875 0.523l6 11q0.273 0.492-0.016 0.984-0.133 0.227-0.363 0.359t-0.496 0.133h-12q-0.266 0-0.496-0.133t-0.363-0.359q-0.289-0.492-0.016-0.984l6-11q0.133-0.242 0.367-0.383t0.508-0.141 0.508 0.141 0.367 0.383z"></path>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-exclamation-triangle.html